import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Typography, makeStyles, Button, Link } from "@material-ui/core";
import CookieNotice from "./Footer/CookieNotice";

const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const setCookie = (name, value, days) => {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

const useStyles = makeStyles(() => ({
  buttons: {
    marginRight: ".5rem",
  },
  header: {
    marginBottom: ".5rem",
  },
}));

const LegalNoticePopup = () => {
  const styles = useStyles();
  const [bottomPopup, setBottomPopup] = useState(false);
  const [showCookieNotice, setShowCookieNotice] = useState(false);

  useEffect(() => {
    getCookie("Cookie_Confirmation") === null && setBottomPopup(true);
  }, []);

  const acceptCookies = () => {
    setCookie("Cookie_Confirmation", 1, 365);
    setBottomPopup(false);
  };

  if (!bottomPopup) return null;

  return (
    <AppBar
      position="fixed"
      elevation={0}
      component="div"
      color="default"
      style={{ top: "auto", bottom: 0, padding: "1rem" }}
    >
      {showCookieNotice && <CookieNotice onExit={() => setShowCookieNotice(false)} />}
      <Toolbar style={{ justifyContent: "center" }}>
        <div style={{ maxWidth: "800px" }}>
          <Typography variant="h5" className={styles.header} color="primary">
            Dina val gällande cookies på denna sida
          </Typography>
          <Typography component="p">
            Cookies är viktiga för att en webbplats ska fungera korrekt. För att förbättra din upplevelse använder vi
            cookies för att komma ihåg inloggningsuppgifter och tillhandahålla säker inloggning, samla in statistik för
            att optimera webbplatsens funktionalitet och leverera innehåll anpassat efter dina intressen. Klicka på
            Godkänn och fortsätt för att acceptera alla cookies och gå direkt till webbplatsen eller klicka på Endast
            nödvändiga för att endast tillåta absolut nödvändiga cookies. Klicka på Visa inställningar för cookies för
            att se detaljerade beskrivningar av de olika typerna av cookies och välja om du vill acceptera specifika
            kategorier av cookies på webbplatsen.
          </Typography>
          <div style={{ marginTop: "1rem" }}>
            <Button color="primary" variant="contained" className={styles.buttons} onClick={acceptCookies}>
              Godkänn och fortsätt
            </Button>
            <Button color="primary" variant="contained" className={styles.buttons} onClick={acceptCookies}>
              Endast nödvändiga
            </Button>
            <Button color="primary" className={styles.buttons} onClick={() => setShowCookieNotice(true)}>
              Visa inställningar för cookies
            </Button>
          </div>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default LegalNoticePopup;
